import React, { useState } from 'react';
import { md } from '../utils/markdown';

const PDFSection = () => {
  const [status, setStatus] = useState('');
  const [summary, setSummary] = useState('');
  const [isUploading, setIsUploading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const file = e.target.pdfInput.files[0];
    if (!file) {
      setStatus('PDF 파일을 선택해주세요.');
      return;
    }

    // 업로드마다 무작위 폴더를 앞에 붙인다. 파일명만으로 키를 만들면 같은 이름의 PDF 를
    // 올린 두 사람이 서로의 요약을 보게 된다. 람다는 키 전체를 그대로 따라가므로
    // 요약도 같은 폴더 아래에 생긴다. .pdf 는 대소문자 무관하게 바꾼다 (람다와 같은 규칙).
    const uploadId = (window.crypto && window.crypto.randomUUID)
      ? window.crypto.randomUUID()
      : `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
    const summaryName = file.name.replace(/\.pdf$/i, '_summary.txt');
    const cloudfrontUrl = `https://arabangoo.com/ai-pdf-folder/${uploadId}/${encodeURIComponent(file.name)}`;
    const summaryUrl = `https://arabangoo.com/ai-pdf-foldersummaries/ai-pdf-folder/${uploadId}/${encodeURIComponent(summaryName)}`;

    try {
      setIsUploading(true);
      setStatus('파일 업로드 중...');

      const uploadResponse = await fetch(cloudfrontUrl, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/pdf',
          'x-amz-acl': 'bucket-owner-full-control'
        },
        body: file
      });

      if (!uploadResponse.ok) {
        throw new Error(`업로드 실패. 상태 코드: ${uploadResponse.status}`);
      }

      setStatus('업로드 성공! 요약 파일 생성 중...');

      const checkSummary = async (retryCount = 0) => {
        const maxRetries = 30;
        const retryInterval = 5000;

        try {
          const response = await fetch(summaryUrl, { method: 'GET' });

          if (response.ok) {
            const summaryText = await response.text();
            setSummary(summaryText);
            setStatus('요약 완료!');
            setIsUploading(false);
          } else if (response.status === 404 && retryCount < maxRetries) {
            setTimeout(() => checkSummary(retryCount + 1), retryInterval);
          } else {
            throw new Error(`요약 파일 로드 실패. 상태 코드: ${response.status}`);
          }
        } catch (error) {
          if (retryCount < maxRetries) {
            console.log(`요약 파일 재시도 중 (${retryCount + 1}/${maxRetries})...`);
            setTimeout(() => checkSummary(retryCount + 1), retryInterval);
          } else {
            console.error('요약 파일 로드 중 오류 발생:', error);
            setStatus('요약 파일 로드 실패!');
            setIsUploading(false);
          }
        }
      };

      checkSummary();
    } catch (error) {
      console.error('업로드 중 오류 발생:', error);
      setStatus('에러 발생: ' + error.message);
      setIsUploading(false);
    }
  };

  return (
    <section className="service-section">
      <h2>PDF 요약 AI 서비스</h2>
      <form onSubmit={handleSubmit}>
        <input type="file" name="pdfInput" accept="application/pdf" />
        <div className="button-container" style={{ marginTop: '10px' }}>
          <button 
            type="submit" 
            className={`category-btn ${isUploading ? 'selected' : ''}`}
            style={{ width: '100%' }}
          >
            업로드하기
          </button>
        </div>
      </form>
      <div className="status">{status}</div>
      {/* 요약본은 표·목록이 이어지는 한 편의 문서라 문단 카드로 쪼개지 않고
          GitHub README 처럼 연속된 문서 흐름으로 렌더한다. */}
      {summary && (
        <div
          className="results"
          dangerouslySetInnerHTML={{ __html: `<div class="markdown-body">${md(summary)}</div>` }}
        />
      )}
    </section>
  );
};

export default PDFSection;